import { useNavigate } from 'react-router-dom'

import useTextContents from 'common/hooks/useTextContents'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import PageVerticalContentStepper from 'components/PageVerticalContentStepper/PageVerticalContentStepper'
import { AppLinks } from 'enviroment/AppLinks'



/**
 * Wersja ekranu dla brokera TRASTI
 * @returns 
 */
const TrastiProductPageContent = () => {
   const pageDetailsTextContents = useTextContents()
   const navigate = useNavigate()
 
   return (
     <section className='payment-details-short-outer-section-wrapper'>
       <h1 className='payment-detail-header'>{pageDetailsTextContents('productPage.trastiBrokerVersion.header')}</h1>
       <PageVerticalContentStepper
          StepOneContentElement={() => <>{pageDetailsTextContents('productPage.trastiBrokerVersion.stepperStage1')}</>}
          StepTwoContentElement={() => (<>{pageDetailsTextContents('productPage.trastiBrokerVersion.stepperStage2')}</>)}
       />
       <Button
          uiButtonType={AppButtonTypes.PRIMARY} 
          buttonContent={pageDetailsTextContents('buttons.next')} 
          className='payment-detail-short-submit-button page-main-button-submission-button' 
          onClick={() => navigate(AppLinks.chooseVerificationMethod)} 
       />
       <ButtonCancelApplication />
     </section>
   )
}

export default TrastiProductPageContent